import type { ReactNode } from "react";

/** Linear-style empty state: glyph cluster, title, one paragraph, actions. */
export function EmptyState({ title, body, actions, icon }: { title: string; body: string; actions?: ReactNode; icon?: ReactNode }) {
  return (
    <div className="mx-auto flex w-full max-w-[440px] flex-col items-start px-5 py-10">
      <div className="mb-7 text-muted" aria-hidden="true">{icon ?? <StatusGlyphs />}</div>
      <h2 className="text-[19px] font-semibold tracking-tight text-fg">{title}</h2>
      <p className="mt-3 text-[14px] leading-[1.75] text-muted">{body}</p>
      {actions && <div className="mt-7 flex flex-wrap items-center gap-2.5 [&>.btn]:h-9 [&>.btn]:rounded-full [&>.btn]:px-3.5">{actions}</div>}
    </div>
  );
}

function StatusGlyphs() {
  return (
    <svg width="104" height="100" viewBox="0 0 104 100" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      {[0, 1, 2, 3].map((state) => (
        <g key={state} transform={`translate(${state % 2 * 54}, ${Math.floor(state / 2) * 50})`}>
          <ellipse cx="24" cy="29" rx="22" ry="16" opacity="0.25" />
          <ellipse cx="24" cy="24" rx="22" ry="16" opacity="0.45" />
          <ellipse cx="24" cy="19" rx="22" ry="16" fill="var(--bg)" opacity="0.8" />
          <ellipse cx="24" cy="19" rx="17" ry="12" strokeDasharray={state === 0 ? "1 3" : undefined} strokeLinecap="round" fill={state === 3 ? "currentColor" : "none"} />
          {state === 2 && <path d="M24 7a17 12 0 0 0 0 24Z" fill="currentColor" stroke="none" />}
          {state === 3 && <path d="m16 19 5 4 10-9" stroke="var(--bg)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />}
        </g>
      ))}
    </svg>
  );
}
